const calculateAge =(birthday)  =>{ // birthday is a date
    let ageDifMs = Date.now() - new Date(birthday).getTime();
    let ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export default calculateAge